import { useEffect } from 'react'
import { InlineElementContainer } from '../atoms/Atoms.tsx'

declare global {
  interface Window {
    InfogramEmbeds: {
      process: () => void
    }
  }
}


export interface InlineInfogramProps {
  id: string
  type: string
  title: string
}

export const InlineInfogram = (props: InlineInfogramProps) => {
  const triggerInfogramRendering = () => {
    if (window.InfogramEmbeds && window.InfogramEmbeds.process) {
      window.InfogramEmbeds.process()
    }
  }

  const scriptId = 'infogram-async'

  useEffect(() => {
    const loadInfogramScript = () => {
      const script = document.createElement('script')
      script.async = true
      script.id = scriptId
      script.src = 'https://e.infogram.com/js/dist/embed-loader-min.js'

      script.onload = () => {
        triggerInfogramRendering()
      }

      document.head.appendChild(script)
    }

    if (!document.getElementById(scriptId)) {
      loadInfogramScript()
    } else {
      // Reason for this: If some charts are rendered before the script loads, sometimes it's necessary to trigger `process' manually for
      // them to render correctly.
      triggerInfogramRendering()
    }
  }, [props.id, props.type, props.title])

  return (
    <InlineElementContainer>
      <div
        className="infogram-embed"
        data-id={props.id}
        data-type={props.type}
        data-title={props.title}
      ></div>
    </InlineElementContainer>
  )
}
